export default __webpack_public_path__ + "static/media/Boton_4.0735171b.png";